import React from 'react'
import { useFormikContext } from 'formik'
import { SectionTitle } from '@/components/FilterBottomSheet/components/SectionTitle'
import { ChipRow } from '@/components/FilterBottomSheet/components/ChipRow'
import type { FormState, FilterBottomSheetProps } from '@/components/FilterBottomSheet/types'
import { FilterBottomSheet } from '@/components/FilterBottomSheet'
import { STATUS_CONFIG as PAYMENT_STATUS_CONFIG } from '@/modules/Wallet/parts/PaymentItem'
import { PaymentStatus } from '@/types/Payment'
import { buildFormState as baseBuildFormState, buildAppliedFilters as baseBuildAppliedFilters, type ConverterConfig } from '@/components/FilterBottomSheet/helpers/converters'
import { PeriodFilter } from '@/components/FilterBottomSheet/components/PeriodFilter'

const CONFIG: ConverterConfig = {
  dateKeys: {
    from: 'createdAtFrom',
    to: 'createdAtTo',
  },
}

const buildFormState = (filters: Record<string, unknown>) =>
  baseBuildFormState(filters, CONFIG)

const buildAppliedFilters = (form: Parameters<typeof baseBuildAppliedFilters>[0]) =>
  baseBuildAppliedFilters(form, CONFIG)



const PAYMENT_STATUSES = (Object.keys(PAYMENT_STATUS_CONFIG) as PaymentStatus[]).map((value) => ({
  value,
  label: PAYMENT_STATUS_CONFIG[value].label,
}))

const PAYMENT_METHODS = [
  { value: 'PIX', label: 'Pix' },
  { value: 'CREDIT_CARD', label: 'Cartão de crédito' },
]

export const StatusChips: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<FormState>()
  return (
    <>
      <SectionTitle>Status</SectionTitle>
      <ChipRow
        options={PAYMENT_STATUSES}
        selected={values.status}
        onChange={(status) => setFieldValue('status', status)}
      />
    </>
  )
}

export const MethodChips: React.FC = () => {
  const { values, setFieldValue } = useFormikContext<FormState>()
  return (
    <>
      <SectionTitle>Método</SectionTitle>
      <ChipRow
        options={PAYMENT_METHODS}
        selected={values.method}
        onChange={(method) => setFieldValue('method', method)}
      />
    </>
  )
}

type PaymentFilterBottomSheetProps = Omit<FilterBottomSheetProps, 'type' | 'buildFormState' | 'buildAppliedFilters'>

export const PaymentFilterBottomSheet: React.FC<PaymentFilterBottomSheetProps> = ({
  filters,
  onApply,
  onClear,
  isOpen,
  onClose,
}) => (
  <FilterBottomSheet
    filters={filters}
    onApply={onApply}
    onClear={onClear}
    isOpen={isOpen}
    onClose={onClose}
    buildFormState={buildFormState}
    buildAppliedFilters={buildAppliedFilters}
  >
    <StatusChips />
    <MethodChips />
    <PeriodFilter />
  </FilterBottomSheet>
)
